const activateLabel = event => {
  if (event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA') {
    const label = document.querySelector(`label[for='${event.target.id}']`);
    if (label) label.classList.add("active");
  }
};

const handleDynamicFormLabels = () => {


  const dynamicForms = document.querySelectorAll('form.dynamic-labels');
  dynamicForms.forEach(form => {

     // handle fields on initial pageload
    const formInputs = form.querySelectorAll(
      "input[type='search'], " +
      "input[type='email'], " +
      "input[type='password'], " +
      "input[type='text'], " +
      "input[type='tel'], " +
      "input[type='number']"
    );
    formInputs.forEach((input) => {
      if (!input.classList.contains("not-dynamic")) {
        // clear out input placeholder text
        input.placeholder = "";
  
        // handle empty input fields
        if (input.value.trim() !== "") {
          const label = document.querySelector(`label[for='${input.id}']`);
          if (label) label.classList.add("active");
        }
        input.addEventListener("change", activateLabel);
      }
	  input.addEventListener("change", activateLabel);
    });
    
    // Event delegation for labels
    form.addEventListener("click", (event) => {
      if (event.target.tagName === 'LABEL') {
        event.target.classList.add("active");
        const labelFor = event.target?.htmlFor;
        if (labelFor && typeof(labelFor) != "undefined") {
          document.querySelector(`input[name='${labelFor}'], textarea[name='${labelFor}']`)?.focus?.();
        }
      }
    });

    // Event delegation for inputs and textareas
    form.addEventListener("focusin", activateLabel);
    form.addEventListener("focusout", (event) => {
      if (!event.target.classList.contains("not-dynamic")) {
        if (event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA') {
          const trimmedString = event.target.value.trim();
          const label = document.querySelector(`label[for='${event.target.id}']`);
          if (label) {
            if(trimmedString === "") {
              label.classList.remove("active");
            }
            event.target.value = trimmedString;
          }
        }
      }
    });

  });

}


export { handleDynamicFormLabels }